import { ModalState, isModalOpen, unwrapModalData } from '@release/shared/utils/modal';
import { Typography } from '@release/ui/Typography';
import { Modal } from '@release/ui/Modal';
import { Icon } from '@release/ui/Icon';
import { Button } from '@release/ui/Button';

import type { ReactNode } from 'react';

// 成功フィードバック（Figma Feedback 7317:41886 / KYC 完了パターン 25292:65663）。
// 本文（アイコン → message → body → detail）と「閉じる」の 2 段構成。
// detail が長い場合（KYC の方式カード等）は本文側だけがスクロールし、「閉じる」は常に下に見える。
// 間隔は Figma に合わせる: 本文要素間 16px / message と body の間 8px / 「閉じる」の上 24px。
export interface SuccessDialogProps {
  state: ModalState<{
    message: string;
    /** 見出しの下に出す補足文（Rabbit / text-medium）。 */
    body?: string;
    /** 補足文の下に出す任意のコンテンツ。指定時はダイアログ幅を広げる。 */
    detail?: ReactNode;
  }>;
  onClose: () => void;
  /** E2E 用。指定時はルートに testId、見出し・補足文・閉じるに `${testId}-title` / `-body` / `-close` を付ける。 */
  testId?: string;
}
export const SuccessDialog: React.FC<SuccessDialogProps> = ({ state, onClose, testId }) => {
  const data = unwrapModalData(state);
  const subTestId = (suffix: string) => (testId ? `${testId}-${suffix}` : undefined);

  return (
    <Modal isOpen={isModalOpen(state)} onRequestClose={onClose}>
      {/* Modal 本体は max-h-[95%] の flex 列。min-h-0 でその高さに収め、本文側にスクロールを閉じ込める。 */}
      <div
        className={`flex min-h-0 flex-col items-center px-6 py-8 ${data?.detail != null ? 'max-w-2xl' : 'max-w-md'}`}
        data-testid={testId}
      >
        <div className="flex min-h-0 w-full flex-1 flex-col items-center gap-y-4 overflow-y-auto">
          <Icon name="check-circle-filled" size="32" className="shrink-0 self-center fill-sem-l-icon-success" />
          <div className="flex w-full flex-col gap-y-2 text-center">
            <Typography weight="bold" data-testid={subTestId('title')}>
              {data?.message}
            </Typography>
            {data?.body ? (
              <Typography size="rabbit" className="text-sem-l-text-medium" data-testid={subTestId('body')}>
                {data.body}
              </Typography>
            ) : null}
          </div>
          {data?.detail != null ? <div className="w-full">{data.detail}</div> : null}
        </div>
        <div className="flex w-full shrink-0 justify-center pt-6">
          <Button variant="secondary" label="閉じる" onClick={onClose} size="xs" data-testid={subTestId('close')} />
        </div>
      </div>
    </Modal>
  );
};
